import {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPostRequestOptions,
  AxiosPutRequestOptions,
} from '@/package';
import type { ModelingApi } from '@/type';
import { apiOf } from '@/util';

export const create = apiOf<
  ModelingApi.Create.Request,
  ModelingApi.Create.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/modeling',
  }),
);

export const get = apiOf<ModelingApi.Get.Request, ModelingApi.Get.Response>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/modeling/:id',
  }),
);

export const getCount = apiOf<
  ModelingApi.GetCount.Request,
  ModelingApi.GetCount.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/modeling/count',
  }),
);

export const getList = apiOf<
  ModelingApi.GetList.Request,
  ModelingApi.GetList.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/modeling',
  }),
);

export const remove = apiOf<
  ModelingApi.Remove.Request,
  ModelingApi.Remove.Response
>(
  new AxiosDeleteRequestOptions({
    url: '/v1/miri/modeling/:pModelingID',
  }),
);

export const update = apiOf<
  ModelingApi.Update.Request,
  ModelingApi.Update.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/modeling/:pModelingID',
  }),
);

export const requestTraining = apiOf<
  ModelingApi.RequestTraining.Request,
  ModelingApi.RequestTraining.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/modeling/:pModelingID/training',
  }),
);

export const deploy = apiOf<
  ModelingApi.Deploy.Request,
  ModelingApi.Deploy.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/modeling/:pModelingID/deploy',
  }),
);

export const removeDeployment = apiOf<
  ModelingApi.Deploy.Request,
  ModelingApi.Deploy.Response
>(
  new AxiosDeleteRequestOptions({
    url: '/v1/miri/modeling/:pModelingID/deploy',
  }),
);

export const getPerformance = apiOf<
  ModelingApi.GetModelingPerformance.Request,
  ModelingApi.GetModelingPerformance.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/modeling/:pModelingID/performance',
  }),
);
